import { ArrowUpRight, CheckCircle2, Clock3, ShieldCheck } from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ cancelled = false }) {
  const [status, setStatus] = useState(cancelled ? "cancelled" : "loading");
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");
  useEffect(() => {
    if (cancelled || !sessionId) return;
    let active = true;
    const poll = async () => {
      try {
        const response = await axios.get(`${API}/payments/status/${sessionId}`);
        if (active) setStatus(response.data.payment_status === "paid" ? "paid" : "pending");
      } catch (error) {
        if (active) setStatus("error");
      }
    };
    poll();
    const timer = window.setInterval(poll, 2500);
    return () => { active = false; window.clearInterval(timer); };
  }, [cancelled, sessionId]);
  const isPaid = status === "paid";
  return (
    <main className="payment-result" data-testid="payment-result-page"><div className="result-mark">{isPaid ? <CheckCircle2 size={48} /> : <Clock3 size={48} />}</div><p className="eyebrow">{cancelled ? "REQUISITION ABORTED" : "DISPATCH RECEIPT / LIVE CHECKOUT"}</p><h1 data-testid="payment-status">{cancelled ? "NO CHARGE.\nCART ON HOLD." : isPaid ? "DISPATCH\nAUTHORIZED." : "PAYMENT\nPROCESSING."}</h1><p>{cancelled ? "Your units are still staged in the armory. Nothing was charged." : isPaid ? "Stripe confirmed the test payment. Your 0.10% after-deployment troop reserve was logged with the requisition." : status === "error" ? "The receipt is not reachable yet. Return to the armory or try the secure checkout again." : "We are waiting for Stripe to confirm the test payment."}</p><div className="result-proof"><span><ShieldCheck size={16} /> {isPaid ? "PAYMENT CONFIRMED" : "SECURE TEST CHANNEL"}</span><span>{sessionId ? `SESSION / ${sessionId.slice(-12).toUpperCase()}` : "SESSION / NOT CREATED"}</span></div><a href="/#armory" className="button button-primary" data-testid="return-armory-result-link">RETURN TO ARMORY <ArrowUpRight size={16} /></a></main>
  );
}
